var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isNotEmptySection)?_c(_vm.component,{tag:"component",style:(_vm.sectionStyle),scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,name){return {key:name,fn:function(){return [_vm._t(name)]},proxy:true}})],null,true)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }